import axios from 'axios';

import Utils from '@/common/utils';

export default {
  search: function (route, request) {
    return axios.get(`/api/${route}/search`, { params: request });
  },
  find: function (id) {
    return axios.get(`/api/investmentRussia/find?id=${id}`);
  },
  // TODO: Вынести в глобальную, т.к. есть дубликаты по логике. Тащить из модуля importAnalytics не хочется
  /**
   * Загрузка файла на сервер
   * @param {string} route - ресурс загрузки файла
   * @param {File} file - файл для загрузки
   * @param {object} additionalOptions - дополнительные параметры
   * @param {string | undefined} [additionalOptions.customRoute] - Пользовательский route, если нужен отличный от ...upload
   * @param {object} [addFormData={}] additionalOptions.addFormData - дополнительные данные в formData
   * @returns {Promise<AxiosResponse>}
   */
  downloadFile: function (route, file, additionalOptions = {}) {
    const apiUrl = additionalOptions.customRoute ? `/api${additionalOptions.customRoute}` : `/api/${route}/upload`;
    let formData = new FormData();
    formData.append('file', file);

    Object.entries(additionalOptions.addFormData ?? {}).forEach(([key, value]) => {
      formData.append(key, value);
    });
    return axios.post(apiUrl, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  uploadInvestmentsFile: function (year, file) {
    let formData = new FormData();
    formData.append('file', file);
    return axios.post(`/api/investment/upload/${year}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  uploadFinancialSector: function (indicator, file) {
    let formData = new FormData();
    formData.append('file', file);
    return axios.post(`/api/financialsector/upload/${indicator}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  uploadFavorTradeFile: function (year, isExport, reportQuartal, file) {
    let formData = new FormData();
    formData.append('file', file);
    return axios.post(`/api/favortrade/uploadforyear/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      params: {
        isExport,
        reportYear: year,
        reportQuartal,
      },
    });
  },
  uploadForeignDirectInvestment: function (isStock, file) {
    let formData = new FormData();
    formData.append('file', file);
    return axios.post(`/api/foreigndirectinvestment/uploaddata/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      params: {
        isStock,
      },
    });
  },
  async mappingCreate(isActive, countryId, countrySourceName) {
    return await axios.post(`/api/countrymapping/create`, {
      isActive,
      countryId,
      countrySourceName,
    });
  },
  uploaddata: function (route, file, params) {
    let formData = new FormData();
    formData.append('file', file);
    return axios.post(`/api/${route}/uploaddata`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      params: params,
    });
  },
  exportExcel: function (request) {
    return Utils.downloadFile('/api/exportPotential/exportExcel', 'exportpotential_registry.xlsx', request);
  },
  exportImportPotentialExcel: function (request) {
    return Utils.downloadFile('/api/importPotential/exportExcel', 'importpotential_registry.xlsx', request);
  },

  refresh: function (route) {
    return axios.get(`/api/${route}/refresh`, {});
  },
  uploadFile: function (route, file, countryId, tradingOperationId, tradeItemTypeId) {
    let formData = new FormData();
    formData.append('file', file);
    formData.append('countryId', countryId);
    formData.append('tradingOperationId', tradingOperationId);
    formData.append('tradeItemTypeId', tradeItemTypeId);
    return axios.post(`/api/${route}/uploaddata`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  getStriTypeList: function () {
    return axios.get(`/api/striindex/getStriTypeList`);
  },
  getTecWorldYears: function () {
    return axios.get(`/api/tecworld/yearList`);
  },
  importCsv: function (name) {
    return axios.get(`/api/exportProduct/importCsv/${name}`);
  },
  calculateSummary: function () {
    return axios.get(`/api/exportProduct/calculateSummary`);
  },
  getUnfriendlyCountriesTemplate: function () {
    return Utils.downloadFile('/api/unfriendlycountries/getuploadtemplate', 'unfriendly_template', {});
  },
};
